var PagesModule = (function () {
    function PagesModule() {
    }
    return PagesModule;
}());
export { PagesModule };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/pages/pages.module.ts.pre-build-optimizer.js